import { type MCPServerInfo } from '../../types';

const GithubOAuthServer: MCPServerInfo = {
  serverId: 'GITHUB_OAUTH',
  name: 'GitHub Copilot',
  slug: 'github-oauth',
  description: 'GitHub Copilot remote MCP Server (Public Preview)',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://api.githubcopilot.com/mcp'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  annotations: {
    hintPreRegistered: true
  }
};

export default GithubOAuthServer;
